import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs';
import {SpecificDirectoryMap} from '@models/data/file-storage/enums/SpecificDirectoryMap.enum';

/**
 * This cache interceptor is only being implemented as a use case for images, specifically of type 'image/svg+xml' which is of a majority
 * the icons around the application - the cache persistence is additionally only RAM oriented so if the user refreshes the browser it will
 * invalidate the cache
 */

@Injectable()
export class CacheInterceptorInterceptor implements HttpInterceptor {
  private cache: Map<string, HttpResponse<any>> = new Map();

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const cachedResponse: HttpResponse<any> = this.cache.get(req.url);
    return cachedResponse
      ? of(cachedResponse.clone())
      : this.sendRequest(req, next);
  }

  isCacheable(req: any): boolean {
    return true;
  }

  /**
   * Get server response observable by sending request to `next()`.
   * Will add the response to the cache on the way out.
   */
  sendRequest(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event) => {
        // There may be other events besides the response.
        if (event instanceof HttpResponse) {
          if (event.headers.has('content-type')) {
            // if has content type header
            const contentType = event.headers.get('content-type');
            const contentTypesToCache = ['image/svg+xml'];

            const containsProfilePic = event.url.includes(`specificDirectoryMap=${SpecificDirectoryMap.ProfilePicture}`)

            const shouldCache = contentTypesToCache.includes(contentType) || containsProfilePic;

            if (shouldCache) {
              this.cache.set(req.url, event.clone()); // Set the cache
            }
          }
        }
      })
    );
  }
}
